import { render } from "./difficultAnalysisPie.vue?vue&type=template&id=2722f305&scoped=true"
import script from "./difficultAnalysisPie.vue?vue&type=script&lang=js"
export * from "./difficultAnalysisPie.vue?vue&type=script&lang=js"

import "./difficultAnalysisPie.vue?vue&type=style&index=0&id=2722f305&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2722f305"]])

export default __exports__